let clientEvent: IEvent;

interface IEvent {
    id: string;
    publicId: Nullable<string>;
    brandId: string;
    settings: {
        allowAddAllToCart: boolean;
        allowCropping: boolean;
        exceedsBigEventThreshold: boolean;
        priceSheetShowPackagesOnly: boolean;
        thumbnailGutterWidth: 's' | 'm' | 'l';
        thumbnailSize: 's' | 'm' | 'l';
        viewType: 'vmason' | 'hmason';
    };
}

export const setEvent = (event: IEvent) => {
    // If the event has a publicId, we don't want the client to use the int id.
    clientEvent = event.publicId ? { ...event, id: event.publicId } : event;
};

const useEvent = () => clientEvent;

export default useEvent;
